"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[205,1243],{

/***/ 48552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ NavMenuProvider; },
/* harmony export */   "m": function() { return /* binding */ useNavMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var NavMenuContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    closeMenu: function() {}
});
var NavMenuProvider = NavMenuContext.Provider;
var useNavMenu = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NavMenuContext);
};


/***/ }),

/***/ 71243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FooterForegroundBox": function() { return /* binding */ FooterForegroundBox; },
  "default": function() { return /* binding */ footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./src/components/helpers/LazyLoad.tsx
var LazyLoad = __webpack_require__(17976);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/ComponentTheme.ts
var ComponentTheme = __webpack_require__(12090);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/FooterAppDownload.tsx



var FooterAppDownload = function(param) {
    var theme = param.theme, appleStoreLink = param.appleStoreLink, appleStoreImageUrl = param.appleStoreImageUrl, googlePlaystoreLink = param.googlePlaystoreLink, googlePlayStoreImageUrl = param.googlePlayStoreImageUrl, locale = param.locale;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterForegroundBox, {
        theme: theme,
        title: "Get the app",
        isAppButtonFooter: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "$2",
            $largerThanSM: {
                justifyContent: "flex-end"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                    href: appleStoreLink,
                    "aria-label": "Opendoor Applestore button",
                    hoverStyle: {
                        color: theme.contentPrimary
                    },
                    color: theme.contentPrimary,
                    analyticsName: "cosmos-landing-page-v2-footer-applesotre-button",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                        source: {
                            uri: appleStoreImageUrl
                        },
                        alt: "Opendoor Applestore",
                        width: 135,
                        height: 45
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                    href: googlePlaystoreLink,
                    "aria-label": "Opendoor Google play button",
                    hoverStyle: {
                        color: theme.contentPrimary
                    },
                    color: theme.contentPrimary,
                    analyticsName: "cosmos-landing-page-v2-footer-googlgplay-button",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                        source: {
                            uri: googlePlayStoreImageUrl
                        },
                        alt: "Opendoor Google Play",
                        width: locale === "es" ? 150 : 135,
                        height: 45
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var footer_FooterAppDownload = (FooterAppDownload);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/FooterBrand.tsx


var OpendoorIconLogo = function(param) {
    var _size = param.size, size = _size === void 0 ? "large" : _size;
    var dimensions = size === "large" ? {
        width: 68,
        height: 94
    } : {
        width: 40,
        height: 55
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: dimensions.width,
        height: dimensions.height,
        viewBox: "0 0 22 30",
        fill: "none",
        style: {
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "Opendoor Icon Logo"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#opendoor_icon_logo)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.2462 11.5378C15.2462 4.44667 14.0271 1.50727 10.6755 1.50727C7.71982 1.50727 6.22677 3.56782 6.22677 10.7197C6.22677 17.7806 7.3847 20.6898 10.7974 20.6898C13.814 20.6898 15.2462 18.6593 15.2462 11.5378ZM0.4375 11.3561C0.4375 3.38602 5.95262 0.234375 10.8584 0.234375C16.0992 0.234375 21.0353 3.35581 21.0353 10.8712C21.0353 18.9018 15.5203 21.9627 10.6145 21.9627C5.37372 21.9627 0.4375 18.6292 0.4375 11.3561ZM19.9597 28.3745C19.4596 27.7147 17.5333 25.1732 17.5333 25.1732C17.3526 24.9347 17.0429 24.7908 16.7105 24.7908H4.76234C4.42997 24.7908 4.12027 24.9347 3.93954 25.1732L1.51348 28.374C1.43651 28.4755 1.39567 28.5937 1.39567 28.7145V29.2031C1.39567 29.366 1.52843 29.498 1.69226 29.498H19.7806C19.9444 29.498 20.0772 29.366 20.0772 29.2031V28.7145C20.0772 28.5937 20.0367 28.4758 19.9597 28.3745Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "opendoor_icon_logo",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "20.7284",
                        height: "29.2637",
                        fill: "white",
                        transform: "translate(0.4375 0.234375)"
                    })
                })
            })
        ]
    });
};
var ChatGptIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#chatgpt_icon)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M117.299 52.7094C118.694 48.5205 119.178 44.0819 118.719 39.6908C118.259 35.2997 116.867 31.0573 114.636 27.2478C111.327 21.4854 106.273 16.9232 100.203 14.2196C94.1329 11.5159 87.361 10.8106 80.8642 12.2054C77.9342 8.90294 74.3326 6.26446 70.3005 4.4665C66.2683 2.66853 61.8987 1.75256 57.4839 1.77989C50.842 1.76393 44.3666 3.85739 38.991 7.75849C33.6155 11.6596 29.6175 17.1668 27.5733 23.4864C23.2457 24.3718 19.1572 26.1717 15.5816 28.7654C12.006 31.3591 9.02585 34.6868 6.84062 38.5257C3.50642 44.2722 2.08339 50.9292 2.77674 57.5367C3.47009 64.1443 6.24399 70.3609 10.6984 75.2901C9.30331 79.4795 8.81919 83.9186 9.27847 88.3103C9.73776 92.7019 11.1299 96.9448 13.3616 100.755C16.6708 106.517 21.7249 111.079 27.7947 113.782C33.8646 116.486 40.6363 117.192 47.1331 115.797C50.0639 119.099 53.6661 121.737 57.6988 123.535C61.7314 125.332 66.1015 126.248 70.5165 126.22C77.1617 126.237 83.6406 124.143 89.0183 120.239C94.396 116.336 98.3944 110.824 100.436 104.501C104.763 103.615 108.851 101.815 112.426 99.2211C116.001 96.6274 118.981 93.2999 121.166 89.4614C124.497 83.7154 125.917 77.0602 125.222 70.4552C124.527 63.8502 121.752 57.6364 117.299 52.7094ZM70.5258 118.093C65.0699 118.101 59.7848 116.191 55.5954 112.695C55.7852 112.593 56.1181 112.412 56.3328 112.279L81.11 97.9673C81.7328 97.6136 82.2499 97.1003 82.6081 96.4801C82.9663 95.8599 83.1526 95.1554 83.1478 94.4393V59.5042L93.6199 65.5522C93.675 65.5794 93.7226 65.6197 93.7585 65.6696C93.7943 65.7195 93.8172 65.7775 93.8252 65.8385V94.769C93.8178 100.949 91.361 106.873 86.993 111.245C82.6251 115.616 76.7024 118.078 70.5227 118.09L70.5258 118.093ZM20.4177 96.6886C17.6855 91.9673 16.701 86.4354 17.6363 81.0613C17.823 81.1733 18.1403 81.3693 18.3736 81.5L43.1508 95.8113C43.7683 96.1718 44.4705 96.3618 45.1855 96.3618C45.9006 96.3618 46.6027 96.1718 47.2202 95.8113L77.473 78.3453V90.4414C77.4766 90.503 77.4648 90.5645 77.4387 90.6204C77.4126 90.6764 77.3731 90.725 77.3237 90.7619L52.2758 105.226C46.9176 108.312 40.5539 109.146 34.5813 107.546C28.6086 105.945 23.5148 102.04 20.4177 96.6886ZM13.8998 42.5982C16.6214 37.8696 20.92 34.2494 26.0426 32.3718C26.0426 32.5834 26.0302 32.9629 26.0302 33.2243V61.85C26.0261 62.5648 26.2125 63.2678 26.5701 63.8867C26.9277 64.5057 27.4436 65.0183 28.0649 65.3718L58.3146 82.8378L47.8425 88.8858C47.7906 88.9202 47.731 88.941 47.6691 88.9464C47.6071 88.9518 47.5448 88.9417 47.4878 88.917L22.4337 74.4439C17.0849 71.3463 13.1828 66.254 11.5831 60.2836C9.9833 54.3132 10.8164 47.9552 13.8998 42.5982ZM99.948 62.6246L69.6952 45.1555L80.1704 39.1106C80.222 39.077 80.281 39.0567 80.3423 39.0513C80.4036 39.0458 80.4653 39.0555 80.522 39.0795L105.573 53.5401C109.411 55.7571 112.537 59.0215 114.587 62.9511C116.637 66.8807 117.525 71.3129 117.147 75.7288C116.769 80.1447 115.14 84.3615 112.453 87.8856C109.765 91.4097 106.129 94.0952 101.97 95.6277V66.1465C101.976 65.4328 101.792 64.7305 101.436 64.1116C101.081 63.4927 100.567 62.9795 99.948 62.6246ZM110.37 46.9351C110.187 46.82 109.866 46.6271 109.636 46.4964L84.8558 32.1852C84.2382 31.8249 83.5361 31.6351 82.8211 31.6351C82.1061 31.6351 81.404 31.8249 80.7864 32.1852L50.5367 49.6511V37.555C50.5332 37.4934 50.545 37.4319 50.571 37.376C50.5971 37.3201 50.6366 37.2715 50.686 37.2345L75.7308 22.7833C79.5684 20.5694 83.9572 19.4944 88.3835 19.6839C92.8099 19.8734 97.0907 21.3197 100.725 23.8534C104.359 26.3872 107.197 29.9036 108.906 33.9913C110.614 38.0789 111.12 42.5687 110.37 46.9351ZM44.8402 68.4923L34.365 62.4442C34.3104 62.4167 34.2634 62.3762 34.2282 62.3263C34.1929 62.2764 34.1704 62.2186 34.1627 62.158V33.2274C34.1664 28.7971 35.4318 24.4594 37.8108 20.722C40.1898 16.9846 43.5841 14.0021 47.5963 12.1234C51.6086 10.2447 56.0729 9.54762 60.467 10.1137C64.861 10.6797 69.0029 12.4854 72.4081 15.3196C72.1607 15.4538 71.9159 15.5928 71.6739 15.7365L46.8936 30.0478C46.2723 30.4013 45.7563 30.9139 45.3987 31.5329C45.0411 32.1518 44.8548 32.8548 44.8589 33.5696L44.8402 68.4923ZM50.5305 56.225L64.0018 48.444L77.4793 56.2219V71.7776L64.0049 79.5555L50.5305 71.7776V56.225Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "chatgpt_icon",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "128",
                        height: "128",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ClaudeIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#claude_icon)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M25.1417 85.0959L50.3014 70.978L50.7223 69.7475L50.3014 69.0675H49.0709L44.8614 68.8085L30.4845 68.4199L18.018 67.9018L5.94012 67.2542L2.89636 66.6066L0.046875 62.8505L0.338299 60.9724L2.89636 59.2563L6.55535 59.5801L14.6505 60.1305L26.7931 60.9724L35.6006 61.4905L48.65 62.8505H50.7223L51.0137 62.0086L50.3014 61.4905L49.7509 60.9724L37.1873 52.4564L23.5875 43.4546L16.4638 38.2737L12.6105 35.6509L10.6677 33.19L9.82578 27.8148L13.3229 23.9615L18.018 24.2854L19.2161 24.6092L23.976 28.2682L34.1435 36.1366L47.4195 45.9155L49.3623 47.5345L50.1395 46.9841L50.2366 46.5955L49.3623 45.1384L42.1415 32.089L34.4349 18.8131L31.0026 13.3084L30.096 10.0056C29.7721 8.64559 29.5455 7.51227 29.5455 6.11991L33.5283 0.71237L35.7302 0L41.0406 0.71237L43.2748 2.6552L46.5776 10.1998L51.9204 22.0835L60.2098 38.2413L62.6383 43.0336L63.9335 47.4698L64.4192 48.8298H65.2611V48.0526L65.9411 38.9537L67.204 27.7824L68.4344 13.4055L68.8554 9.35796L70.863 4.50089L74.8458 1.87807L77.9543 3.36757L80.5123 7.02656L80.1562 9.39034L78.6343 19.2664L75.6553 34.7442L73.7124 45.106H74.8458L76.141 43.8108L81.3866 36.849L90.1941 25.8396L94.0798 21.4683L98.613 16.6436L101.527 14.3445H107.032L111.08 20.3673L109.266 26.5844L103.6 33.7728L98.9045 39.8604L92.1693 48.9269L87.9599 56.1801L88.3484 56.763L89.3522 56.6658L104.571 53.4278L112.796 51.9383L122.607 50.2545L127.043 52.3268L127.529 54.4316L125.78 58.7382L115.289 61.3286L102.984 63.7895L84.657 68.1285L84.4304 68.2904L84.6894 68.6142L92.9464 69.3914L96.4759 69.5856H105.122L121.215 70.7837L125.424 73.5684L127.95 76.9684L127.529 79.5588L121.053 82.8616L112.31 80.7893L91.9103 75.9322L84.9161 74.1837H83.9447V74.7665L89.7732 80.4655L100.459 90.1149L113.832 102.549L114.512 105.625L112.796 108.054L110.982 107.795L99.2283 98.9547L94.695 94.9719L84.4304 86.3263H83.7504V87.233L86.1142 90.6977L98.613 109.478L99.2606 115.242L98.354 117.12L95.1159 118.253L91.5541 117.606L84.2361 107.341L76.6915 95.7814L70.6039 85.4197L69.8592 85.8406L66.2649 124.535L64.5812 126.511L60.6955 128L57.4574 125.539L55.7413 121.556L57.4574 113.688L59.5298 103.423L61.2136 95.2633L62.7355 85.1283L63.6421 81.7607L63.5774 81.534L62.8326 81.6312L55.1908 92.1224L43.5662 107.827L34.3702 117.671L32.1683 118.545L28.3474 116.57L28.7036 113.04L30.8407 109.899L43.5662 93.7091L51.2404 83.6711L56.1946 77.875L56.1622 77.0331H55.8708L22.0656 98.9871L16.0428 99.7642L13.4524 97.3357L13.7762 93.3529L15.0067 92.0577L25.1741 85.0635L25.1417 85.0959Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "claude_icon",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "128",
                        height: "128",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var GeminiIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#gemini_icon)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M63.9783 128C63.9783 119.131 62.2876 110.811 58.8604 103.04C55.5702 95.2686 51.0006 88.4571 45.2429 82.6971C39.4852 76.9371 32.7222 72.4114 24.9539 69.12C17.1856 65.6914 8.86893 64 0.00390625 64C8.86893 64 17.1856 62.3543 24.9539 59.0171C32.7222 55.5886 39.5309 51.0171 45.2429 45.2571C51.0006 39.4971 55.5245 32.7314 58.8604 24.96C62.2876 17.1886 63.9783 8.86857 63.9783 0C63.9783 8.86857 65.6234 17.1886 68.9592 24.96C72.3864 32.7314 76.956 39.5429 82.7137 45.2571C88.4714 51.0171 95.2344 55.5886 103.048 59.0171C110.817 62.3086 119.133 64 127.998 64C119.133 64 110.817 65.6914 103.048 69.12C95.2801 72.4114 88.4714 76.9371 82.7137 82.6971C76.956 88.4571 72.3864 95.2229 68.9592 103.04C65.6283 110.937 63.9339 119.429 63.9783 128Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "gemini_icon",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "128",
                        height: "128",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var GrokIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M49.7584 82.176L91.3872 49.408C93.43 47.8052 96.3495 48.423 97.32 50.9245C102.439 64.0807 100.148 79.8943 89.9653 90.7576C79.7825 101.613 65.6158 103.992 52.6596 98.5711L38.5111 105.558C58.8037 120.348 83.4481 116.689 98.8436 100.263C111.059 87.2431 114.839 69.4929 111.301 53.4817L111.33 53.5124C106.201 29.9937 112.588 20.5969 125.682 1.38017C125.985 0.923826 126.3 0.461913 126.614 0L109.389 18.3624V18.3012L49.748 82.1843M41.1644 90.1343C26.6012 75.3057 29.1136 52.3492 41.5349 39.104C50.7211 29.3037 65.7827 25.3078 78.9241 31.1819L93.0439 24.2337C90.5028 22.2748 87.2415 20.1711 83.4977 18.6852C66.5967 11.2668 46.3511 14.9565 32.6096 29.5986C19.3952 43.6897 15.2365 65.3579 22.372 83.8483C27.7048 97.664 18.9621 107.445 10.1568 117.304C7.02863 120.796 3.90569 124.299 1.38281 128L41.1462 90.1343",
            fill: "currentColor"
        })
    });
};
var PerplexityIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M105.52 0V38.784H120V93.9733H104.347V128L66.816 94.9653V127.739H60.9973V94.928L23.424 128V93.52H8V38.336H23.3813V0L60.9973 34.6347V1.01333H66.8107V35.6267L105.52 0ZM66.816 48.2347V87.2693L98.528 115.184V77.0133L66.816 48.2347ZM60.9547 47.808L29.2427 76.5973V115.184L60.9547 87.2693V47.8133V47.808ZM104.347 88.2347H114.181V44.528H71.7867L104.347 74.0747V88.2347ZM56.4427 44.0747H13.8133V87.7813H23.4133V74.0427L56.4373 44.0693L56.4427 44.0747ZM29.2 13.2053V38.3253H56.48L29.2 13.2053ZM99.7013 13.2053L72.4213 38.3253H99.7013V13.2053Z",
            fill: "currentColor"
        })
    });
};
var buildAiDeeplinks = function(prompt) {
    var encodedPrompt = encodeURIComponent(prompt);
    return {
        chatgpt: "https://chat.openai.com/?q=".concat(encodedPrompt),
        claude: "https://claude.ai/new?q=".concat(encodedPrompt),
        gemini: "https://www.google.com/search?udm=50&aep=11&q=".concat(encodedPrompt),
        grok: "https://x.com/i/grok?text=".concat(encodedPrompt),
        perplexity: "https://www.perplexity.ai/?q=".concat(encodedPrompt)
    };
};
var FooterBrand = function(param) {
    var footerTitle = param.footerTitle, theme = param.theme, aiPrompt = param.aiPrompt;
    var aiDeeplinks = aiPrompt ? buildAiDeeplinks(aiPrompt) : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        alignItems: "center",
        flexShrink: 0,
        gap: "$20x",
        $largerThanSM: {
            alignItems: "flex-start",
            maxWidth: 280,
            gap: "$12x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                alignItems: "center",
                gap: "$24x",
                $largerThanSM: {
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "$20x"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        style: {
                            color: (0,cjs.getToken)(theme.contentPrimary)
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorIconLogo, {
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h2",
                        typography: "$subheaderMedium",
                        maxWidth: 200,
                        $largerThanSM: {
                            typography: "$headerMedium",
                            maxWidth: 280
                        },
                        color: theme.contentPrimary,
                        children: footerTitle
                    })
                ]
            }),
            aiDeeplinks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                borderColor: "$borderPrimary",
                borderTopWidth: "$1x",
                $largerThanSM: {
                    borderBottomWidth: 0,
                    py: "$12x"
                },
                borderBottomWidth: "$1x",
                py: "$20x",
                gap: "$8x",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: theme.contentPrimary,
                        textAlign: "center",
                        maxWidth: 300,
                        $largerThanSM: {
                            textAlign: "left",
                            typography: "$bodyLarge"
                        },
                        children: "Want to learn more? Ask AI for a summary of Opendoor and how we can help you sell your home."
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                        gap: "$6x",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        $largerThanSM: {
                            justifyContent: "flex-start",
                            gap: "$14x"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: aiDeeplinks.chatgpt,
                                "aria-label": "Ask ChatGPT about Opendoor",
                                target: "_blank",
                                variant: "secondaryInverse",
                                textDecorationLine: "none",
                                analyticsName: "cosmos-footer-ai-deeplink-chatgpt",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChatGptIcon, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: aiDeeplinks.claude,
                                "aria-label": "Ask Claude about Opendoor",
                                target: "_blank",
                                variant: "secondaryInverse",
                                textDecorationLine: "none",
                                analyticsName: "cosmos-footer-ai-deeplink-claude",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClaudeIcon, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: aiDeeplinks.gemini,
                                "aria-label": "Ask Gemini about Opendoor",
                                target: "_blank",
                                variant: "secondaryInverse",
                                textDecorationLine: "none",
                                analyticsName: "cosmos-footer-ai-deeplink-gemini",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GeminiIcon, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: aiDeeplinks.grok,
                                "aria-label": "Ask Grok about Opendoor",
                                target: "_blank",
                                variant: "secondaryInverse",
                                textDecorationLine: "none",
                                analyticsName: "cosmos-footer-ai-deeplink-grok",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrokIcon, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                href: aiDeeplinks.perplexity,
                                "aria-label": "Ask Perplexity about Opendoor",
                                target: "_blank",
                                variant: "secondaryInverse",
                                textDecorationLine: "none",
                                analyticsName: "cosmos-footer-ai-deeplink-perplexity",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PerplexityIcon, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer_FooterBrand = (FooterBrand);

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/FooterHelpCenter.tsx



var FooterHelpCenter = function(param) {
    var theme = param.theme, helpCenterLink = param.helpCenterLink;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterForegroundBox, {
        theme: theme,
        title: "Still have questions?",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
            href: helpCenterLink,
            "aria-label": "Opendoor Help Center button",
            analyticsName: "cosmos-landing-page-v2-footer-help-center",
            variant: "secondaryInverse",
            size: "xsmall",
            label: "Visit the Help Center",
            maxWidth: "$450x",
            hoverStyle: {
                backgroundColor: "$backgroundInverseStateHoverPrimary"
            }
        })
    });
};
/* harmony default export */ var footer_FooterHelpCenter = (FooterHelpCenter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/FooterLegal.tsx





var FooterLegal = function(param) {
    var theme = param.theme, extraLegalText = param.extraLegalText, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showEligibilityLegal = param.showEligibilityLegal, showPromotionLegal = param.showPromotionLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        backgroundColor: theme.bgPrimaryLight,
        borderRadius: "$6x",
        padding: "$8x",
        gap: "$8x",
        // @ts-expect-error expect TODO
        color: "$contentPrimary",
        children: [
            extraLegalText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                gap: "$8x",
                // @ts-expect-error dynamic children inherit this color
                color: theme.contentPrimary,
                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(extraLegalText, {
                    renderNode: (0,_define_property/* default */.Z)({}, dist.INLINES.HYPERLINK, function(node, children) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                            href: node.data.uri,
                            analyticsName: "cosmos-footer",
                            "aria-label": "",
                            variant: "secondaryInverse",
                            children: children
                        });
                    })
                })
            }),
            showEligibilityLegal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: "Offer eligibility and purchase price vary."
            }),
            showCustomerTestimonialLegal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: "Featured customers may have been compensated for their time. Their opinions and views are solely their own."
            }),
            showThePdpCopyrightLegal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: "Data is subject to copyright, and provided solely for personal, not commercial use. All property information should be verified by the recipient and none is guaranteed as accurate."
            }),
            showPromotionLegal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: "Eligibility may vary. Not all promotions may be combined."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: "CA: Opendoor Brokerage Inc. DRE #02061130"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: [
                    "NY:",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                        "aria-label": "Licensed as Opendoor Brokerage LLC pdf link",
                        href: "https://odfil.es/static/documents/Dan+NY+Notarized+Doc.pdf",
                        variant: "secondaryInverse",
                        children: "Licensed as Opendoor Brokerage LLC"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                        "aria-label": "Fair Housing Notice pdf link",
                        href: "https://odfil.es/static/documents/fair-housing-notice.pdf",
                        variant: "secondaryInverse",
                        children: "Fair Housing Notice"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: [
                    "TX:",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                        "aria-label": "TREC Information About Brokerage Services pdf link",
                        href: "https://odfil.es/static/IABS_Jan_2026.pdf",
                        variant: "secondaryInverse",
                        children: "TREC Information About Brokerage Services"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "cosmos-landing-page-v2-footer-legal-link",
                        "aria-label": "TREC Consumer Protection Notice pdf link",
                        href: "https://www.trec.texas.gov/forms/consumer-protection-notice",
                        variant: "secondaryInverse",
                        children: "TREC Consumer Protection Notice"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                color: theme.contentPrimary,
                children: [
                    "Opendoor Labs Inc. is dedicated to improving the accessibility of its Website and we view accessibility as a continually ongoing effort. Please contact us at",
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        href: "mailto:support@opendoor.com",
                        "aria-label": "Contact support link",
                        analyticsName: "cosmos-contact-opendoor-email",
                        variant: "secondaryInverse",
                        children: "support@opendoor.com"
                    }),
                    " ",
                    "with any support needs, feedback or suggestions."
                ]
            })
        ]
    });
};
/* harmony default export */ var footer_FooterLegal = (FooterLegal);

// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(46000);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/FooterNav.tsx



var FooterNav = function(param) {
    var footerNav = param.footerNav, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        flex: 1,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
            flexWrap: "wrap",
            $largerThanSM: {
                flexWrap: "nowrap"
            },
            justifyContent: "space-between",
            gap: "$12x",
            children: footerNav && footerNav.map(function(navItem, i) {
                var ref;
                var ref1;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    flex: 1,
                    flexBasis: "45%",
                    gap: "$12x",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "h3",
                            typography: "$subheaderSmall",
                            color: theme.contentPrimary,
                            children: navItem.fields.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                            tag: "ul",
                            padding: 0,
                            gap: "$8x",
                            children: ((ref1 = (ref = navItem.fields.links) === null || ref === void 0 ? void 0 : ref.filter(function(link) {
                                return link != null && (0,utils/* isSimpleLink */.$)(link);
                            })) !== null && ref1 !== void 0 ? ref1 : []).map(function(link, i) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        analyticsName: "footer-link-column-".concat(link.fields.text || ""),
                                        typography: "$bodyMedium",
                                        href: link.fields.url || "",
                                        variant: "secondaryInverse",
                                        textDecorationLine: "none",
                                        children: link.fields.text || ""
                                    })
                                }, i);
                            })
                        })
                    ]
                }, i);
            })
        })
    });
};
/* harmony default export */ var footer_FooterNav = (FooterNav);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/footer/Footer.tsx











var DEFAULT_APPLE_STORE_LINK = "https://apps.apple.com/us/app/opendoor-buy-sell-homes/id1143708068";
var DEFAULT_GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en";
var DEFAULT_HELP_CENTER_LINK = "https://help.opendoor.com/";
var FooterSellInYourMarket = function(param) {
    var sellInYourMarket = param.sellInYourMarket, theme = param.theme;
    if (!(sellInYourMarket === null || sellInYourMarket === void 0 ? void 0 : sellInYourMarket.length)) {
        return null;
    }
    var sortedMarkets = (0,_to_consumable_array/* default */.Z)(sellInYourMarket).sort(function(a, b) {
        return a.label.localeCompare(b.label);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        width: "100%",
        padding: "$4",
        alignItems: "flex-start",
        backgroundColor: theme.bgPrimaryLight,
        borderRadius: "$6x",
        gap: "$4",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                minWidth: "$20",
                flexShrink: 0,
                typography: "$labelSmall",
                color: theme.contentPrimary,
                children: "Learn about selling in your market"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                gap: "$2",
                flexWrap: "wrap",
                alignItems: "flex-end",
                flex: 1,
                minWidth: 0,
                children: sortedMarkets.map(function(market, i) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                tag: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                    analyticsName: "footer-link-column-".concat(market.label),
                                    typography: "$bodyMedium",
                                    href: "/sell/".concat(market.path),
                                    variant: "secondaryInverse",
                                    textDecorationLine: "none",
                                    children: market.label
                                })
                            }),
                            i < sortedMarkets.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                tag: "span",
                                children: "|"
                            })
                        ]
                    }, market.path);
                })
            })
        ]
    });
};
var FooterForegroundBox = function(param) {
    var children = param.children, title = param.title, theme = param.theme;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        $largerThanSM: {
            flexDirection: "row",
            justifyContent: "space-between"
        },
        width: "100%",
        padding: "$4",
        gap: "$2",
        backgroundColor: theme.bgPrimaryLight,
        borderRadius: "$6x",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                flexShrink: 0,
                typography: "$labelSmall",
                color: theme.contentPrimary,
                children: title
            }),
            children
        ]
    });
};
var Footer = function(param) {
    var siteFooter = param.siteFooter, extraLegalText = param.extraLegalText, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showEligibilityLegal = param.showEligibilityLegal, showPromotionLegal = param.showPromotionLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal;
    var footerTitle = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.footerTitle;
    var footerNav = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.footerNav;
    var sellInYourMarket = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.sellInYourMarket;
    var _googlePlaystoreLink;
    var googlePlaystoreLink = (_googlePlaystoreLink = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.googlePlaystoreLink) !== null && _googlePlaystoreLink !== void 0 ? _googlePlaystoreLink : DEFAULT_GOOGLE_PLAY_LINK;
    var _appleStoreLink;
    var appleStoreLink = (_appleStoreLink = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.appleStoreLink) !== null && _appleStoreLink !== void 0 ? _appleStoreLink : DEFAULT_APPLE_STORE_LINK;
    var _helpCenterLink;
    var helpCenterLink = (_helpCenterLink = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.helpCenterLink) !== null && _helpCenterLink !== void 0 ? _helpCenterLink : DEFAULT_HELP_CENTER_LINK;
    var backgroundColor = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.backgroundColor;
    var locale = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.sys.locale;
    var aiPrompt = siteFooter === null || siteFooter === void 0 ? void 0 : siteFooter.fields.aiPrompt;
    var theme = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(backgroundColor && backgroundColor in ComponentTheme/* BNColorThemes */.CW ? backgroundColor : ComponentTheme/* BNColorThemes.Grey */.CW.Grey);
    var appleStoreImageUrl = locale === "es" ? "https://images.opendoor.com/source/s3/imgdrop-production/2025-06-1750894044413-61865.png?service=cosmos" : "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078078-95093.png?service=cosmos";
    var googlePlayStoreImageUrl = locale === "es" ? "https://images.opendoor.com/source/s3/imgdrop-production/2025-06-1750894682317-95550.png?service=cosmos" : "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078081-28903.png?service=cosmos";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        tag: "footer",
        backgroundColor: theme.bgPrimary,
        // @ts-expect-error theme token type mismatch with getCSSVariable
        style: {
            color: (0,cjs.getToken)(theme.contentPrimary)
        },
        minHeight: "$113",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    display: "block",
                    maxWidth: "$360",
                    mx: "auto",
                    p: "$5",
                    pt: "$22",
                    $largerThanSM: {
                        p: "$20"
                    },
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        gap: "$16",
                        maxWidth: "100vw",
                        $largerThanMD: {
                            flexDirection: "row"
                        },
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(footer_FooterBrand, {
                                footerTitle: footerTitle,
                                theme: theme,
                                aiPrompt: aiPrompt
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$4",
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(footer_FooterNav, {
                                        footerNav: footerNav,
                                        theme: theme
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterSellInYourMarket, {
                                        sellInYourMarket: sellInYourMarket,
                                        theme: theme
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        $largerThanLG: {
                                            flexDirection: "row"
                                        },
                                        gap: "$4",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(footer_FooterAppDownload, {
                                                theme: theme,
                                                appleStoreLink: appleStoreLink,
                                                appleStoreImageUrl: appleStoreImageUrl,
                                                googlePlaystoreLink: googlePlaystoreLink,
                                                googlePlayStoreImageUrl: googlePlayStoreImageUrl,
                                                locale: locale
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(footer_FooterHelpCenter, {
                                                theme: theme,
                                                helpCenterLink: helpCenterLink
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(footer_FooterLegal, {
                                        theme: theme,
                                        extraLegalText: extraLegalText,
                                        showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                        showEligibilityLegal: showEligibilityLegal,
                                        showPromotionLegal: showPromotionLegal,
                                        showThePdpCopyrightLegal: showThePdpCopyrightLegal
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        pt: "$16",
                                        alignItems: "center",
                                        gap: "$4",
                                        flexWrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$bodyMedium",
                                                color: theme.contentPrimary,
                                                children: [
                                                    "\xa9 ",
                                                    new Date().getFullYear(),
                                                    " Opendoor | All rights reserved."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$4",
                                                alignItems: "center",
                                                // @ts-expect-error theme token type mismatch with getCSSVariable
                                                style: {
                                                    color: (0,cjs.getToken)(theme.contentPrimary)
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                                        source: {
                                                            uri: "https://images.opendoor.com/source/s3/imgdrop-production/f2398a1e83a24962a9297d13f2ac6ea5.png?preset=square-2048"
                                                        },
                                                        alt: "Equal Housing Opportunity",
                                                        width: 38,
                                                        height: 38
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                        href: "https://www.bbb.org/us/az/tempe/profile/real-estate-services/opendoor-1126-1000060421/#sealclick",
                                                        analyticsName: "cosmos-landing-page-v2-footer-bbb-link",
                                                        "aria-label": "Better Business Bureau accredited since June 8th 2021 link",
                                                        hoverStyle: {
                                                            color: theme.contentPrimary
                                                        },
                                                        color: theme.contentPrimary,
                                                        textDecorationLine: "underline",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                                            source: {
                                                                uri: "https://images.opendoor.com/source/s3/imgdrop-production/1cd65eee0b8345689ceff0292986f125.png?preset=square-2048"
                                                            },
                                                            alt: "Better Business Bureau",
                                                            width: 105,
                                                            height: 38
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var footer_Footer = (Footer);


/***/ }),

/***/ 205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_theme_ODThemeLite__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67079);
/* harmony import */ var cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96887);
/* harmony import */ var components_landing_pages_v2_shared_footer_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71243);
/* harmony import */ var components_landing_pages_v2_shared_header_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32681);
/* harmony import */ var components_landing_pages_v2_shared_NavMenuContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48552);
/* harmony import */ var components_shared_GlobalStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54991);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);










var setHeight = "\n  html,\n  body,\n  div#__next {\n    height: 100%;\n  }\n";
var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceMapLayout = function(param) {
    var children = param.children, header = param.header, footer = param.footer;
    var ref;
    var megaNavData = (header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : ref.mainNav) ? (0,cms__WEBPACK_IMPORTED_MODULE_1__/* .transformHeaderNavToMegaNav */ .$C)(header.fields.mainNav) : undefined;
    var closeMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function() {});
    var navMenuValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            closeMenu: function() {
                return closeMenuRef.current();
            }
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_opendoor_bricks_theme_ODThemeLite__WEBPACK_IMPORTED_MODULE_8__/* .ThemedLite */ .h, {
        baseTheme: "novo",
        team: "marketplace",
        launchDateString: new Date().toISOString(),
        overrides: {},
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("style", {
                        children: setHeight
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_shared_GlobalStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_landing_pages_v2_shared_NavMenuContext__WEBPACK_IMPORTED_MODULE_4__/* .NavMenuProvider */ .d, {
                value: navMenuValue,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_landing_pages_v2_shared_header_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            slug: "homes",
                            mainNavLinks: mainNavLinks,
                            menuPanelNavLinks: menuPanelNavLinks,
                            megaNavData: megaNavData,
                            closeMenuRef: closeMenuRef
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                            tag: "main",
                            tabIndex: -1,
                            display: "flex",
                            overflow: "hidden",
                            backgroundColor: "$backgroundPrimary",
                            height: "calc(100% - 72px)",
                            children: children
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(components_landing_pages_v2_shared_footer_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            siteFooter: footer
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarketplaceMapLayout);


/***/ })

}]);